// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1UdfM","choiceBoxes":"toolbarselects_choiceBoxes__8Juz0","simpleField":"toolbarselects_simpleField__1z_oO"};